import {
  RELATION__ACCOUNTS_STARRED
} from '../../dictionaries/Relations.dic';
import Account from '../../lib/Account';
import Core from "../../lib/Core";
import {
  ACCOUNT_ACTION__EDIT_ACCOUNT,
  STATE_ACTIVE
} from '../../lib/Definition';
import {
  mapAccounts
} from '../../lib/models/account';
import AccountDetails from '../Accounts/Card/AccountDetails';
import {
  moreMenuOptionsAccounts
} from './3DotsMenu/moreMenuOptionsAccounts';
import ButtonDownloadAccountCSV from './ButtonDownloadAccountCSV';
import {
  FilterDateRangeColumn
} from './FilterDateRangeColumn';
import {
  FilterStringColumn
} from './FilterStringColumn';
import {
  CellActionsColumn,
  CellTagColumn,
  FilterActionsColumn, FilterTagColumn
} from "./ReactTable";
import {
  REACT_TABLE__COLUMN_MD,
  REACT_TABLE__COLUMN_SM,
  REACT_TABLE__COLUMN_XL,
  REACT_TABLE__COLUMN_XXL,
  REACT_TABLE__COLUMN_XXXL
} from './useEnhancedReactTable.hook';

export const configAccounts = {
  Entity: Account,
  entityMapper: mapAccounts,
  searchPath: 'Accounts/_search',
  autocompletePath: 'Accounts/_autocomplete',
  facetsPath: 'Accounts/_facets',
  starredAccessor: RELATION__ACCOUNTS_STARRED,
  searchPlaceholder: 'Search by company or recruiter name',
  addNew: () => Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_ACCOUNT }) && {
    label: '+ New Account',
    to: '/account/create'
  },
  ActionBar: ButtonDownloadAccountCSV,
  defaultQuery: {
    "filters": [
      {
        "state": STATE_ACTIVE,
      }
    ],
    // "sort": { "firstName": 1, "lastName": 1 },
    "skip": 0,
    "limit": 10,
    "query": [],
    "associations": [
      'subrole',
      RELATION__ACCOUNTS_STARRED
    ]
  },
  hiddenColumns: [
    'state',
  ],
  columns: [
    {
      accessor: 'firstName',
      Header: 'Fullname',
      Cell: CellTagColumn,
      disableFilters: false,
      width: REACT_TABLE__COLUMN_SM,
      _headerClassName: 'sticky-start bg-cyan-common',
      _cellClassName: 'sticky-start bg-white-common',
      _accessor: '_infoCmp',
    },
    {
      accessor: 'role',
      Header: 'Role',
      disableFilters: false,
      width: REACT_TABLE__COLUMN_MD,
    },
    {
      accessor: 'subrole.label',
      Header: 'Subrole',
      Filter: FilterStringColumn,
      Cell: CellTagColumn,
      disableFilters: false,
      width: REACT_TABLE__COLUMN_MD,
    },
    {
      accessor: 'companyName',
      Header: 'Company Name',
      disableFilters: false,
      width: REACT_TABLE__COLUMN_MD,
    },
    {
      accessor: 'leftCompanyFlag',
      Header: 'Left company',
      Cell: CellTagColumn,
      disableFilters: false,
      width: REACT_TABLE__COLUMN_MD,
    },
    {
      accessor: 'newCompanyName',
      Header: 'New company',
      Cell: CellTagColumn,
      disableFilters: false,
      width: REACT_TABLE__COLUMN_XL,
    },
    {
      accessor: 'phone',
      Header: 'Phone',
      disableFilters: false,
      width: REACT_TABLE__COLUMN_SM,
    },
    {
      accessor: 'email',
      Header: 'Email',
      Cell: CellTagColumn,
      _accessor: '_emailCmp',
      disableFilters: false,
      width: REACT_TABLE__COLUMN_XXXL,
    },
    {
      accessor: 'interactions',
      _accessor: '_interactions',
      Header: 'Interactions',
      Cell: CellTagColumn,
      disableFilters: false,
      width: REACT_TABLE__COLUMN_XXXL,
    },
    {
      accessor: 'expertise',
      _accessor: '_expertise',
      Header: 'Expertise',
      Cell: CellTagColumn,
      disableFilters: false,
      width: REACT_TABLE__COLUMN_XXXL,
    },
    {
      accessor: 'announcements',
      _accessor: '_announcements',
      Header: 'Announcements',
      Cell: CellTagColumn,
      disableFilters: false,
      width: REACT_TABLE__COLUMN_XXXL,
    },
    {
      accessor: 'state',
      Header: 'State',
      Filter: FilterTagColumn,
      Cell: CellTagColumn,
      disableSortBy: false,
      width: 120,
      _acl: [Core.isAdminOrCoordinator()],
      _accessor: '_state',
      _categoryKey: 'state',
    },
    {
      accessor: 'createdAt',
      _accessor: '_createdAt',
      Header: 'Created',
      Cell: CellTagColumn,
      Filter: FilterDateRangeColumn,
      width: REACT_TABLE__COLUMN_XXL,
      disableFilters: false,
    },
    {
      accessor: 'updatedAt',
      _accessor: '_updatedAt',
      Header: 'Updated',
      Cell: CellTagColumn,
      Filter: FilterDateRangeColumn,
      width: REACT_TABLE__COLUMN_XXL,
      disableFilters: false,
    },
    /** */
    {
      id: 'actions',
      Header: 'Actions',
      Filter: FilterActionsColumn,
      Cell: CellActionsColumn,
      defaultCanFilter: true,
      disableFilters: false,
      disableSortBy: false,
      width: 170,
      _starredAccessor: `${RELATION__ACCOUNTS_STARRED}.starred`,
      _headerClassName: 'sticky-end bg-cyan-common c-white-all bl-1',
      _cellClassName: 'sticky-end bg-white-common bl-1 d-flex flex-align-right-center',
    }
  ],
  moreMenuOptions: moreMenuOptionsAccounts,
  ExpandedView: AccountDetails,
};
